/** The XP progress and available KP that both campaign and chapter heroes show. */
import { useTranslation } from 'react-i18next';
import { xpFraction } from '../xp-fraction';
import stat from '../stat.module.css';

export function CampaignStats({ earnedXp, totalXp, kpBalance }: { earnedXp: number; totalXp: number; kpBalance: number }) {
  const { t } = useTranslation();
  return <>
    <div>
      <span className={stat.statLabel}>⭐ {t('student.campaign.totalXp')}</span>
      <span className={stat.statValue}>{xpFraction(earnedXp, totalXp)}</span>
    </div>
    <div>
      <span className={stat.statLabel}>🏆 {t('student.campaigns.kp')}</span>
      <span className={stat.statValue}>{t('student.progress.kpBalance', { balance: kpBalance })}</span>
    </div>
  </>;
}
